module.exports = __webpack_public_path__ + "img/edit-icon.1554a1f2.svg";